
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dieu-khoan-giao-dich",
      function () {
        return require("private-next-pages/dieu-khoan-giao-dich.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dieu-khoan-giao-dich"])
      });
    }
  